<template>
    <k-panel v-if="list_type && contents" class="elevation-1">
        <template #title>{{content_list.name}}
        </template>
        <template #default>
            <k-data-table 
                :headers="headers" 
                :items="contract_items"
                :rows-per-page-items='[15, 20, 30]'
                :pagination.sync="pagination"
                item-key="value">
                <template v-slot:items="props">
                    <tr>
                    <td>{{ props.item.title }}</td>
                    <td>{{ props.item.customer_name }}</td>
                    <td>{{ format_datetime(props.item.last_billed) }}</td>
                    </tr>
                </template>
            </k-data-table>
        </template>
    </k-panel>
</template>

<script>
import Vue from 'vue'
import datelib from '@/lib/date.js'

import * as FormItems from '@/components/form_items'

export default {
	props: ["list","search", "editpath", "disable-import", "chosen_headers", "chosen_items"],
	data () {
		return {
			channel: undefined,
			list_data: {},
            pagination: {'sortBy': 'last_billed'}
		}
	},
    components: {
        ...FormItems
    },
	computed: {
        headers () {
            var ret = this.$props.chosen_headers;
            return ret;
        },
        contract_items () {
            let ret = [];
            for (const item of this.contents) {
                let current_item = {};
                for (const item_info of this.$props.chosen_items) {
                    current_item[item_info.value] = _.at(item, item_info.path)[0]
                }
                ret.push(current_item);
            }
            return ret;
        },
        content_list () {
            return _.find(this.content_lists, (cl) => {
                return cl.id == this.list;
            });
        },
        list_type () {
            var cl = this.content_list;
            return _.find(this.list_types, (lt) => {
                return lt.id == cl.cms_list_type_id;
            });
        },
        content_lists () {
            return Object.values(this.$store.state.cms_lists);
        },
        list_types () {
            return Object.values(this.$store.state.cms_list_types);
        },
        contents () {
            return Object.values(this.list_data);
        }

    },
    mounted() {
        this.connect_ws();
    },
	methods: {
        connect_ws () {
            var self = this;
            this.channel = this.$cloudserver.channel("cms:list_datas:"+this.list);
            this.channel.on("init", function(msg) {
                msg.list_data.forEach(function(d) {
                    Vue.set(self.list_data, d.id, d);
                });
            });
            this.channel.on("update", function(msg) {
                console.log("List data update", msg);
                Vue.set(self.list_data, msg.list_data.id, msg.list_data);
            });
            this.channel.on("delete", function(msg) {
                console.log("List data delete", msg);
                Vue.delete(self.list_data, msg.list_data.id);
            });
            this.channel.join();
        },
        format_datetime (time) {
            return datelib.format_date(time);
        }
	}
}
</script>

<style scoped>
</style>
